import { defineComponent, computed, openBlock, createElementBlock, createElementVNode, toDisplayString, createVNode, unref } from "vue";
import { CdrRating } from "@rei/cedar";
const _hoisted_1 = {
  class: "ratings-overview"
};
const _hoisted_2 = {
  class: "ratings-overview__product-rating"
};
const _hoisted_3 = {
  "data-ui": "native-reviews-average-rating"
};
const _hoisted_4 = {
  class: "ratings-overview__review-count"
};
const _hoisted_5 = {
  class: "ratings-overview__rating-summary",
  "data-ui": "rating-summary"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductReviewsRatingOverview",
  props: {
    averageRating: {},
    reviewCount: {},
    positiveRecs: {},
    totalRecs: {},
    recommendedPercentage: {}
  },
  emits: ["metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const productRating = computed(() => Math.round(props.averageRating * 10) / 10);
    const emit = __emit;
    function onReviewClick() {
      emit("metricsClick", {
        linkName: "reviews_product rating volume"
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("section", _hoisted_1, [createElementVNode("div", _hoisted_2, [createElementVNode("span", _hoisted_3, toDisplayString(productRating.value), 1), createVNode(unref(CdrRating), {
        id: "cdr-rating",
        rating: _ctx.averageRating,
        href: "#first-review",
        onClick: onReviewClick
      }, null, 8, ["rating"]), createElementVNode("span", _hoisted_4, [createElementVNode("a", {
        "data-ui": "review-count",
        href: "#first-review",
        onClick: onReviewClick
      }, toDisplayString(_ctx.reviewCount) + " Reviews ", 1)])]), createElementVNode("div", _hoisted_5, toDisplayString(_ctx.positiveRecs) + " out of " + toDisplayString(_ctx.totalRecs) + " (" + toDisplayString(_ctx.recommendedPercentage) + "%) reviewers recommend this product ", 1)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductReviewsRatingOverview2.mjs.map
